import React from "react";

export const ModalTitleSteps = (props) => (
  <div className="modal-title-steps dx-toolbar dx-widget dx-visibility-change-handler dx-collection" role="toolbar">
    <div className="dx-toolbar-items-container">
      <div className="dx-toolbar-before">
        <div className="dx-item dx-toolbar-item dx-toolbar-label">
          <div className="dx-item-content dx-toolbar-item-content">
            <div>{props.title}</div>
          </div>
        </div>
      </div>

      <div className="dx-toolbar-after">
        <div className="steps dx-toolbar-item">
          Paso
          <span className="number-title-modal">{props.currentStep}</span>
          de
          <span className="number-title-modal">{props.totalSteps}</span>
        </div>
        <div onClickCapture={props.onClose} className="dx-item dx-toolbar-item dx-toolbar-button">
          <div className="dx-item-content dx-toolbar-item-content">
            <div className="dx-closebutton dx-button dx-button-normal dx-button-mode-contained dx-widget dx-button-has-icon">
              <div className="dx-button-content">
                <i className="dx-icon dx-icon-close"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
